import { cva, VariantProps } from 'class-variance-authority';
import { ReactNode } from 'react';

const badgeVariants = cva('inline-flex items-center justify-center rounded-bzc-circular', {
  variants: {
    variant: {
      primary: 'bg-primary-background-low text-primary-foreground-main',
      secondary: 'bg-secondary-background-low text-secondary-foreground-main',
      error: 'bg-error-background-low text-error-foreground-main',
      success: 'bg-success-background-low text-success-foreground-main',
      warning: 'bg-warning-background-low text-warning-foreground-main',
      info: 'bg-info-background-low text-info-foreground-main',
      promo: 'bg-promo-background-low text-promo-foreground-main',
      dimmed: 'bg-neutral-background-disabled-low text-neutral-foreground-disabled'
    },
    size: {
      medium: 'py-tiny-small px-tiny-large caption-xsmall-semibold',
      large: 'py-tiny-medium px-normal-small caption-small-semibold'
    }
  },
  defaultVariants: {
    variant: 'primary',
    size: 'medium'
  }
});

export interface BadgeProps extends VariantProps<typeof badgeVariants> {
  label: ReactNode;
  className?: string;
}

export const Badge = ({ variant, className, label, size }: BadgeProps) => {
  return <div className={badgeVariants({ variant, size, className })}>{label}</div>;
};
